import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'src/common/withStyles';

import { decorateComponent, getClassNameFor } from '../../helpers';
import Svg from '../Svg';
import s from './SuperOwner.module.scss';

const SuperOwner = ({ classNameModifier }) => (
  <span className={getClassNameFor(s, 'root', classNameModifier)}>
    Super Owner
    <Svg
      href="#super-owner-badge"
      className={getClassNameFor(s, 'badge', classNameModifier)}
    />
  </span>
);

SuperOwner.propTypes = {
  classNameModifier: PropTypes.string,
};

const decorators = [
  withStyles(s),
];

export default decorateComponent(SuperOwner, decorators);
